import PropTypes from 'prop-types';

const MessageAttachmentShape = PropTypes.shape({
  filename: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  sizeString: PropTypes.string.isRequired,
  mainUrl: PropTypes.string,
  fmUrl: PropTypes.string,
  iconUrl: PropTypes.string,
  previewable: PropTypes.bool,
});

export default MessageAttachmentShape;
